import Axios, { AxiosError } from 'axios';
import eventEmitter from '../utils/eventEmitter';
import { authApi } from './authApi';

/**
 * Define a baseURL para o Acta.
 */
function mountBaseUrlActa() {
  const env = process.env.NODE_ENV;
  if (env === 'development') {
    return 'http://localhost:8002/api';
  }
  return 'https://acta.publisol.com.br/api';
}

// Cria a instância do Axios para ACTA
const actaApi = Axios.create({
  baseURL: mountBaseUrlActa(),
  withCredentials: true,
});

actaApi.interceptors.response.use(
  (response) => response,
  async (error: AxiosError) => {
    const originalRequest = error.config;

    // Se vier 401 (exceto se for o refresh do Connect, mas aqui não chamamos refresh via actaApi)
    if (error.response?.status === 401 && originalRequest) {
      // Evita múltiplas tentativas
      if (!(originalRequest as any)._retry) {
        (originalRequest as any)._retry = true;
        try {
          // Tenta renovar token via authApi
          await authApi.post('/token/refresh/');
          // Reexecuta a requisição original agora com novo cookie
          return actaApi(originalRequest);
        } catch (refreshError) {
          // Se falhar o refresh, emite logout
          eventEmitter.emit('logout');
          return Promise.reject(refreshError);
        }
      } else {
        // Já tentou refresh, mas falhou
        eventEmitter.emit('logout');
      }
    }

    return Promise.reject(error);
  },
);

export { actaApi };